import React, { useState, useEffect, useRef } from 'react'
import store from "@/redux/store";
import { v4 as uuid } from "uuid";
import {hideModal, detailDossier as detailDossierModal} from "@/reducers/ModalPopup";    
import {quickSearch} from "@/reducers/Dossier"
import moment from 'moment';
import { useTranslation, withTranslation, Trans } from "react-i18next";

import CommunicationCycleReducer, {getState, getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';

import {addCalenderItem} from '@/reducers/ModalPopup';
import { useNavigate } from "react-router-dom";
import { Link, useLocation, Navigate } from "react-router-dom";

import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Dialog,
  DialogPanel,
  DialogBackdrop,
} from '@headlessui/react'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { CalendarIcon, ListBulletIcon, PhoneIcon, DocumentPlusIcon, FolderIcon, FolderPlusIcon, HashtagIcon, TagIcon } from '@heroicons/react/24/outline'

import { open, close, setPos } from '@/reducers/Window'
import {WINDOW} from "@/actions/globalConst";

        

export function CommunicationCycleHeader({...props}) {
    const [searchtxt, setSearchTxt] = useState(null);  
    const [query, setQuery] = useState([])  
    const currentEventRef = useRef(null);
const { t, i18n, ready } = useTranslation();
let eventTypes = null;
let eventType = "todo";
 let history = useNavigate();
 
 const addCalenderItemEvent=(event, eventTypeId, eventTypeName) => {
      store.dispatch( newTaskEvent(eventTypeName) );
        if(eventTypeId == 1) {
            store.dispatch( open({...WINDOW.TODO_WINDOW}) );
        } else if(eventTypeId == 2) {
            store.dispatch( open({...WINDOW.CONTACT_WINDOW}) );
        } else if(eventTypeId == 3) {
            store.dispatch( open({...WINDOW.APPOINTMENT_WINDOW}) );
        }
      
      }    

          const onNewDossierEventHandler= ((event) => {
              event.preventDefault();
              event.stopPropagation();
      //        store.dispatch( searchWorkprocesses() );
      //        store.dispatch( searchWorkprocessModal({createNewDossierHandler: createNewDossier}) );
              store.dispatch( open({...WINDOW.CREATE_DOSSIER}) );
              return false;
          });
 
   const addCalenderItemEventOLD=(event, eventTypeId) => {
        store.dispatch( newTaskEvent(eventTypeId) );
        if(eventTypeId == 1) {
            
        } else if(eventTypeId == 2) {
            store.dispatch( addCalenderItem({parent:null, users:store.getState().CommunicationCycleReducer.users,priorities:store.getState().CommunicationCycleReducer.priority,onCloseEvent:closeEventHandler, onSaveEvent: onSaveEventHandler, scheduleTask: null, checkAvailability: null }) );
            
            } else if(eventTypeId == 3) {
                
                }
        }    

    const closeEventHandler=(event) => {
        store.dispatch( hideModal(null) );
        }    
        
        const onSaveEventHandler=(data) => {
            if(props?.parent) {
                data['parent'] = props?.parent["key"]; 
            }
            store.dispatch( saveTask(data) );
            //.then(() => history("/home"));
//            if(props?.onSubmitHandler) {
//                props?.onSubmitHandler(event);
//            }
            store.dispatch( hideModal(null) );
        }

        const getIcon= (eventType) =>  {
            
            let icon = null;
            switch(eventType) {
                case 'Document':
                    icon = (<DocumentPlusIcon aria-hidden="true" className="-ml-0.5 size-5" />);
                    break;
                case 'Afspraak':
                    icon = (<CalendarIcon aria-hidden="true" className="-ml-0.5 size-5" />);        
                    break;
                case 'Contact':
                    icon = (<PhoneIcon aria-hidden="true" className="-ml-0.5 size-5" />);        
                    break;
                case 'Todo':
                    icon = (<ListBulletIcon aria-hidden="true" className="-ml-0.5 size-5" />);        
                    break;
            }
            
            
            return icon;
        }
        
        
  useEffect(() => {
      const state = store.getState();
       
   return () => {
//            worker.port.postMessage({type: 'close'});
      //connection.disconnect();
    };
  }, []);    

    const state = store.getState();
    eventTypes = state.CommunicationCycleReducer.event_types;

    return (
        <>
            <div ref={currentEventRef} className="h-full rounded-md py-1 px-1 text-left text-gray-900 shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-600 sm:text-sm sm:leading-4 grid grid-rows-2">
                <div className="col-span-3 hidden">{t('Communicationcycles')}</div>
                <div className="col-span-3">
                
                <button
                  key={"new_dossier_button"}
                  type="button"
                  onClick={(event) => onNewDossierEventHandler(event)}
                  className="inline-flex ml-2 items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {getIcon("Document")}
                  {"Nieuw dossier"}
                </button>                      
                
                
                {eventTypes && Object.keys(eventTypes).map((eventType, idx) => {
                    let eventTypeId = eventTypes[eventType]
                  return(
      <button
        key={eventType}
        type="button"
        onClick={(event) => addCalenderItemEvent(event, eventTypeId, eventType)}
        className="inline-flex ml-2 items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        {getIcon(eventType)}
        {eventType}
      </button>                      

                  )    
                      
                      
                  })}
                
                </div>

            </div>
        </>
      );    
}
